var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPower = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 42,
  height: 48,
  fill: "none",
  viewBox: "0 0 48 48"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#power_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M37.508 17.813a3.33 3.33 0 0 0-2.842-1.618h-6.922l2.113-6.117c.291-.984.073-1.969-.583-2.812C28.618 6.492 27.671 6 26.651 6h-9.546c-1.676 0-3.06 1.266-3.28 2.672l-3.788 14.906c-.146.985.145 1.899.801 2.672.656.703 1.676 1.125 2.697 1.125h7.14l-2.55 10.688a3.32 3.32 0 0 0 .583 2.742A3.4 3.4 0 0 0 21.331 42c1.24 0 2.332-.562 2.842-1.477l13.335-19.476c.656-.985.656-2.18 0-3.235m-15.812 20.39L25.048 24H13.462l3.643-14.625h9.327L22.935 19.57h11.44z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "power_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h48v48H0z"
})))));
export default SvgPower;